import React from "react";
import { TickBoxAndLabelSectionRenderer } from "../../../../libraries/ReportGenerator/TickBoxAndLabelSectionRenderer";
import { getFormSummary } from "../../utils/getFormSummary";

export const ReasonAndCloseConfirmSection = ({ inspectionData, isSwitch }) => {
  const reasonForTestData = inspectionData && inspectionData.tasks[0];
  const closeForTestForm =
    inspectionData &&
    inspectionData.tasks[0].appForms &&
    inspectionData.tasks[0].appForms.find((form) => form.id === "LIRR_CloseConfirmation");
  const closeForTestData = closeForTestForm && getFormSummary(closeForTestForm);

  return (
    <React.Fragment>
      <span className="spacer"></span>
      <TickBoxAndLabelSectionRenderer
        title={"Reason For Test"}
        titleStyle={{ textDecoration: "underline", textUnderlineOffset: "4px" }}
        data={reasonForTestData || {}}
        rows={isSwitch ? SwitchReasonForTestSchema : ReasonForTestSchema}
      />
      {!isSwitch && <span className="spacer"></span>}
      {!isSwitch && (
        <TickBoxAndLabelSectionRenderer
          title={"Close Confirmation"}
          titleStyle={{ textDecoration: "underline", textUnderlineOffset: "4px" }}
          data={closeForTestData || {}}
          rows={CloseForSchema}
        />
      )}
    </React.Fragment>
  );
};

const ReasonForTestSchema = [
  [
    { title: "Periodic", id: "reasonForTest", tickBox: true },
    { title: "Gate Replacement", id: "reasonForTest", tickBox: true },
    { title: "Trouble Call", id: "reasonForTest", tickBox: true },
    { title: "Revision", id: "reasonForTest", tickBox: true },
    { title: "OTHER", id: "reasonForTest", otherValId: "reasonForTestComments", tickBox: true },
  ],
];

const SwitchReasonForTestSchema = [
  [
    { title: "Periodic", id: "reasonForTest", tickBox: true },
    { title: "Switch Trouble", id: "reasonForTest", tickBox: true },
    { title: "New Install", id: "reasonForTest", tickBox: true },
    { title: "OTHER", id: "reasonForTest", otherValId: "reasonForTestComments", tickBox: true },
  ],
];
const CloseForSchema = [
  [
    { title: "Directional Relays Down", id: "dronif" },
    { title: "Key cut-out Normal", id: "kcutout" },
    { title: "POR is Up", id: "porup" },
  ],

  [
    { title: "Rectifier is On", id: "recton" },
    { title: "EH/WH are Up", id: "ehwhup" },
    { title: "NWP Up, RWP Down, XP Up", id: "nwprwpxp" },
  ],
  [{ title: "Gravity Down Tested Properly (Gate Replacement)", id: "gravitydown", tickBox: true }],
  [{ title: "Vertical Torque (Ft/lbs)", id: "vtorque" }, { title: "Horizontal Torque (Ft/lbs)", id: "htorque" }, { title: "" }],
];



// WEBPACK FOOTER //
// ./src/components/Reports/LIRR/utils/ReasonAndCloseConfirmSection.jsx